import { get,post } from "../../api_helper";
import { MAIN_MENU,GETAPI_MENU } from "../../url_helper";
const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createmainmenu = (payload)=>post(`${baseURL}${MAIN_MENU}`,payload);
export const getmainmenu = ( )=>get(`${baseURL}${GETAPI_MENU}`)